<template lang="html">
  <div v-if="!this.$store.getters.hasSendRequest">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(handlePasswordReset)" class="Form">
        <div class="Form__wrapper">
          <h1 class="title-3">Password Recovery</h1>
          <p class="text-xlg text-semi">
            Fill in your details to retrieve your password
          </p>
          <formly-form
            :form="form"
            :model="model"
            :fields="fields"
            tag="div"
            class="Form__group"
          ></formly-form>
        </div>
        <button class="btn btn--primary btn--min">
          Send password recovery email
        </button>
      </form>
      <router-link :to="{ name: 'signup' }" class="clickable nav-link block mt-16 text-md">
      Click here to register
      </router-link>
      <router-link
        :to="{ name: 'login' }"
        class="clickable nav-link block mt-8 text-md"
        >Log in</router-link
      >
    </ValidationObserver>
  </div>
  <div v-else>
    <h1 class="title-3">Check your inbox!</h1>
    <p class="text-xlg text-semi">
      You should receive email with instructions on resetting your password!
    </p>
  </div>
</template>

<script>
  export default {
    name: 'PasswordRecovery',
    data: function() {
      return {
        model: {
          email: null,
        },
        form: {},
        fields: [
          {
            key: 'email',
            type: 'input',
            rules: 'required|email',
            templateOptions: {
              type: 'email',
              label: 'Email Address',
              layout: 'full',
              autocomplete: 'email',
            },
          },
        ],
      }
    },
    created() {
      this.$store.commit('requestReset', false)
    },
    methods: {
      handlePasswordReset() {
        this.$store.dispatch('REQUEST_PASSWORD_RESET', this.model)
      },
    },
  }
</script>
